import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Row } from 'components/shared/Layout';
import SectionHeaderBar from 'components/ui/SectionHeaderBar';
import { StyledColumn } from './Panel.styles';

const Panel = ({ title, subtitle, children }) => (
  <>
    <SectionHeaderBar>
      <span>
        <FormattedMessage id={title} />
        {subtitle && <> - {subtitle}</>}
      </span>
    </SectionHeaderBar>
    <Row>
      <StyledColumn span={8}>{React.Children.toArray(children)[0]}</StyledColumn>
      {React.Children.toArray(children)[1] ? <StyledColumn span={8}>{React.Children.toArray(children)[1]}</StyledColumn> : ''}
    </Row>
  </>
);

Panel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  children: PropTypes.node
};

export default Panel;
